export default {
  buttons: {
    signup: 'Zarejestruj się',
    login: 'Zaloguj się',
  },
};
